import React from "react";

import { AnimationOnScroll } from "react-animation-on-scroll";
import { Button, Col, Container, Row } from "react-bootstrap";
import { NavLink } from "react-router-dom";

import { getUrlLangPrefix } from "@/utils/Local";

import i18n from "../../i18n";

const SignatureModelsScreen: React.FC = () => {
  const { t } = i18n;
  const langPrefix = getUrlLangPrefix();

  return (
    <Container fluid className="screenContainer introContainer">
      <Container className="flexContainer">
        <Row className="w-100 pt-2 pb-2 mt-2 mt-lg-0">
          <Col className="mt-4 mt-lg-0 order-2 order-lg-1" lg={6} xs={12}>
            <AnimationOnScroll animateOnce animateIn="animate__fadeInLeftBig">
              <div className="ratio ratio-16x9 text-center mt-4 mb-4 ">
                <iframe
                  allowFullScreen
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  className="embed-responsive-item w-100 rounded"
                  height="315"
                  src="https://www.youtube.com/embed/vG2Cv1pLTnE?si=Rey3is6a5AZaUlZc"
                  title="YouTube video player"
                  width="560"
                />
              </div>
            </AnimationOnScroll>
          </Col>

          <Col className="order-1 order-lg-2 ps-0 ps-lg-5" lg={6} xs={12}>
            <div className="flexContainer introContent" style={{ gap: "8px" }}>
              <h2>{t("PakVille™ Home Kits")}</h2>
              <p>
                {t(
                  "Modern, energy-efficient modular homes delivered and assembled in weeks.",
                )}
              </p>
              <NavLink to={`${langPrefix}/${t("_route.models")}/overview`}>
                <Button className="btn-primary">{t("Learn More")}</Button>
              </NavLink>
            </div>
          </Col>
        </Row>
      </Container>
    </Container>
  );
};

export default SignatureModelsScreen;
